import React from 'react';
import classNames from 'classnames';

import Button from 'components/partials/button/button';

import { getTestId } from 'helpers/test-helpers';

interface ActionsDropdownItemProps {
  label: string;
  startIcon?: React.ReactNode;
  isDelete?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
  hideDropdownCallback?: () => void;
  customClass?: string;
}

const ActionsDropdownItem = ({
  label,
  startIcon,
  isDelete,
  isDisabled,
  onClick,
  hideDropdownCallback,
  customClass,
}: ActionsDropdownItemProps): React.JSX.Element => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    e.stopPropagation();
    onClick?.();
    hideDropdownCallback?.();
  };

  const dataTestId = getTestId({
    prefix: 'actions-dropdown-item',
    label,
  });

  return (
    <Button
      className={classNames(
        'gap-1.5 text-gray-600 hover:text-gray-600 hover:bg-navy-50 !justify-start w-full !p-2 whitespace-nowrap',
        {
          '!text-critical-500 hover:text-critical-500': isDelete,
        },
        customClass
      )}
      disabled={isDisabled}
      variant="reserve-text"
      iconBefore={startIcon}
      onClick={handleClick}
      data-testid={dataTestId}
    >
      {label}
    </Button>
  );
};

export default ActionsDropdownItem;
